<template>

  <div class="card-body">
      <div class="row g-0" v-for="com in comments">
        <div class="col-auto sw-3 d-flex flex-column justify-content-center align-items-center position-relative me-4">
          <div class="rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center">
            <img v-if="com.avatar" :src="settings.backendUrl+com.avatar" class="img-fluid rounded-xl" alt="thumb">
            <i class="fa fa-2x fa-user-tie" v-else></i>
          </div>
          <div class="w-100 d-flex h-100 justify-content-center position-relative">
            <div class="line-w-1 bg-separator h-100 position-absolute"></div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="h-100">
            <div class="d-flex flex-column justify-content-start">
              <div class="d-flex flex-column">
                <div class="heading mb-0">{{split(com.who)}}</div>
                <div class="text-muted small">{{com.posted_on|from_now}}</div>
                
                <div v-html="com.text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <form class="row gx-3 gy-2 align-items-center d-flex align-items-center" v-if="!readOnly">
        <div class="input-group">
          <textarea class="form-control resizable"
                    placeholder="Votre message"
                    aria-describedby="button-area"
                    rows="3"
                    v-model="current_text"></textarea>
          <button @click="create_comment" class="btn btn-outline-primary" type="button" id="button-area">Envoyer</button>
        </div>
      </form>
    </div>
</template>


<script>
import settings from "@/settings.coffee";

export default {
  name: "EstablishmentStateComments",
  props: {
    comments: Array,
    readOnly: null
  },
  data() {
    return {
      current_text: ""
    };
  },
  computed: {
    settings() {
      return settings;
    }
  },
  methods: {
    split(txt) {
      let ret = txt;
      if (txt) {
        ret = txt.split(" ")[0];
      }
      return ret;
    },
    create_comment() {
      const text = this.current_text.replace(/(?:\r\n|\r|\n)/g, "<br>");
      this.comments.push({
        who: this.$store.state.profile.data.fullname,
        text: text,
        avatar: this.$store.state.profile.data.avatar,
        posted_on: new Date()
      });
      this.$emit("comments:added", this.comments);
      // scroll_down n'est pas défini dans ce composant, à ajouter si nécessaire
      this.current_text = "";
    }
  },
  mounted() {
    // rien à faire ici pour l'instant
  }
};
</script>

<style>
  pre{
    background-color:rgba(255,255,255,0);
    font-family:"Nunito Sans", sans-serif;
    font-size:14px;
    padding:0;
    white-space: pre-wrap;
  }
  textarea.resizable{
      resize:vertical;
  }
</style>
